import { AxiosResponse } from 'axios';

import { WebhookMessage, WebhookRequestMessage } from '../../../../types/WebhookMessages';
import { authorizedAxiosInstance } from '../instances/AuthorizedAxiosInstance';

export const createWebhook = async (
    webhookRequestMessage: WebhookRequestMessage
): Promise<AxiosResponse<WebhookMessage>> => {
    return authorizedAxiosInstance.post('/v1/webhooks', webhookRequestMessage);
};

export const deleteWebhook = async (webhookId: string): Promise<AxiosResponse<void>> => {
    return authorizedAxiosInstance.delete(`/v1/webhooks/${webhookId}`);
};

interface UpdateWebhookParams {
    webhookId: string;
    webhook: WebhookRequestMessage;
}

export const updateWebhook = async ({
    webhookId,
    webhook,
}: UpdateWebhookParams): Promise<AxiosResponse<WebhookMessage>> => {
    return authorizedAxiosInstance.put(`/v1/webhooks/${webhookId}`, webhook);
};
